import { Component, OnInit } from '@angular/core';


import {homeComponentService} from '../services/app.services'
import{IContact,IContactMessage,IAboutUs} from '../model/app.model'

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html'
    
})

export class ContactComponent implements OnInit {
    
    getContact : IContact
    sendContactMessage:IContactMessage
    
    
    


    constructor(private homeService: homeComponentService) {

    
  }

    ngOnInit() {

        
        /*this.homeService.getContact().subscribe(contact => {
        this.getContact = contact;


        })*/

 

  }

  onSendMsg(form)
  {
      console.log(form.value);
      this.homeService.saveEvent(form.value).subscribe();
  }
    
}



// WEBPACK FOOTER //
// /apps/dev/flashqubes/src/app/home/contact.component.ts